import { toggleMark } from "prosemirror-commands";
import { MenuItem } from "prosemirror-menu";
import type { MarkType } from "prosemirror-model";

import type { PathIconSpec } from "../icons";
import { isFormulaSelected, isImageSelected, isSelectionInCodeBlock, markActive } from "../utils";

/**
 * Creates a toolbar MenuItem for toggling a mark (bold, italic, code, etc.)
 *
 * Menu items have three key properties:
 * - active: Whether the item should appear highlighted (mark is currently applied)
 * - enable: Whether the item is clickable (can the mark be toggled in current context)
 * - run: What happens when the item is clicked (toggles the mark)
 */
export function markItem(
  markType: MarkType,
  options: { title: string; icon: PathIconSpec },
): MenuItem {
  return new MenuItem({
    title: options.title,
    icon: options.icon,
    active(state) {
      return markActive(state, markType);
    },
    enable(state) {
      return !isSelectionInCodeBlock(state) && !isFormulaSelected(state) && !isImageSelected(state);
    },
    run(state, dispatch) {
      return toggleMark(markType)(state, dispatch);
    },
  });
}
